import {useMutation, useQuery} from '@tanstack/react-query';
import {useTranslation} from 'react-i18next';
import {acceptCodeOfConduct, getCodeOfConductStatus} from '@/data/code-of-conduct-api';

export const codeOfConductKeys = {
    all: ['codeOfConduct'] as const,
    status: (orgId: string, locale: string) => [...codeOfConductKeys.all, 'status', orgId, locale] as const,
};

export const useCodeOfConductStatus = (orgId: string, enabled = true) => {
    const {i18n} = useTranslation();
    const locale = i18n.language;

    return useQuery({
        queryKey: codeOfConductKeys.status(orgId, locale),
        queryFn: () => getCodeOfConductStatus(orgId, locale),
        enabled,
        staleTime: 0,
    });
};

export const useAcceptCodeOfConduct = (orgId: string) => {
    return useMutation({
        mutationFn: ({versionId, locale}: {versionId: string; locale: string}) =>
            acceptCodeOfConduct(orgId, versionId, locale),
    });
};
